import { loadLocale } from "./loadLocale";

export function loadCategoryMapLocale(locale: string, isLocaleLoaded: boolean, onT0Click) {
  if (isLocaleLoaded) {
    return;
  }
  loadLocale(locale, "category-map-t2", "category-map")
    .then(() => {
      onT0Click();
    });
}
